export default __webpack_public_path__ + "static/media/Paused.e86e3810.svg";